// extracted by mini-css-extract-plugin
export default {"actions":"index_actions__LsGBZ","description":"index_description__httXa"};